import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { environment } from '@env/environment';

export interface Device {
  id: number;
  phone_id: string;
  dienstnummer: number | null;
  label: string;
  active: number;
  last_seen?: string | null;
  created?: string | null;
  token?: string; // write-only
}

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class DeviceService {
  errorMsg = '';

  constructor(private httpClient: HttpClient) {}

  getAll(): Observable<Device[]> {
    return this.httpClient
      .get<any>(`${environment.serverUrl}/devices`, httpOptions)
      .pipe(
        map((response) => (response?.data || []) as Device[]),
        catchError((error) => this.handleError(error))
      );
  }

  save(device: Device): Observable<any> {
    const url =
      device.id && device.id > 0
        ? `${environment.serverUrl}/devices/${device.id}`
        : `${environment.serverUrl}/devices`;
    return this.httpClient
      .post<any>(url, JSON.stringify(device), httpOptions)
      .pipe(catchError((error) => this.handleError(error)));
  }

  setActive(id: number, active: number): Observable<any> {
    return this.httpClient
      .post<any>(`${environment.serverUrl}/devices/${id}/activate`, JSON.stringify({ active }), httpOptions)
      .pipe(catchError((error) => this.handleError(error)));
  }

  delete(id: number): Observable<any> {
    return this.httpClient
      .delete<any>(`${environment.serverUrl}/devices/${id}/0/0`, httpOptions)
      .pipe(catchError((error) => this.handleError(error)));
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      this.errorMsg = `Error: ${error.error.message}`;
    } else {
      this.errorMsg = `Server error: ${error.status}`;
    }
    return throwError(this.errorMsg);
  }
}
